import { useLocation, useSearchParams } from 'react-router-dom'
import { CircularProgress, Typography } from '@mui/material'
import { useStytchIsAuthorized } from '@stytch/react/b2b'
import NotFound from '@/pages/NotFound'
import { useGetProjects } from '@/service-library/hooks/projects'
import { Project } from '@/types/projects'
import { useCurrentAccountContext } from '@/components/accounts/CurrentAccountProvider'
import ProjectWizard from './ProjectWizard'

export default function ProjectWizardPage() {
  const { rootOrganization } = useCurrentAccountContext()
  const { isAuthorized: canAddEditProject } = useStytchIsAuthorized(
    'pd.project',
    'edit',
  )
  const [searchParams] = useSearchParams()
  const projectIdParam = searchParams.get('project_id')
  const { state } = useLocation()
  const { category } = state || {}

  const { projects = [], isPending } = useGetProjects({
    refetchOnWindowFocus: false,
    filters: {
      limit: '1000',
    },
  })

  const defaultProject: Project = {
    id: '',
    processing_active: false,
    setup_state: 'field_config',
    name: '',
    color: 'blue',
    org_id: rootOrganization.id,
    project_category_id: category?.id,
    project_category: category,
    source_folder_url: '',
    remove_duplicate_entities: false,
    namespace_id: '',
    account_id: rootOrganization.account_id,
    org_credential_type_id: null,
    exclude_from_doc_routing: false,
  }

  const project = projects.find(
    (projectItem) => projectItem.id === projectIdParam,
  )

  if (!canAddEditProject) return <NotFound />

  return isPending ? (
    <Typography align="center" p={8}>
      <CircularProgress />
    </Typography>
  ) : (
    <ProjectWizard
      projects={projects}
      existingProject={project || defaultProject}
    />
  )
}
